<template>
  <div class="rounded-full text-sm p-1 bg-white/20 text-light-950 dark:text-dark-50">
    <div class="relative">
      <ButtonBase class="opacity-0 pointer-events-none" v-bind="{ ...button, ...(currentItem?.button || {}) }">
        <span class="text-sm">{{ currentItem?.label }}</span>
      </ButtonBase>

      <div class="absolute top-0 left-0 w-full bottom-0 flex items-center">
        <div
          class="font-medium flex flex-col h-full grow items-center justify-center cursor-pointer transition leading-none"
          :class="[
            isSeparations && i < options.length - 1 && !modelValue ? 'border-r border-light-600/50 dark:border-dark-400/30' : ''
          ]"
          v-for="(option, i) in options"
          :key="`${option.value}`"
          @click.stop.prevent="() => {
            modelValue === option.value && isResettable ? emit('reset') : emit('update:modelValue', option.value);
            emit('change');
          }"
          :data-value="option.value"
          ref="$items"
        >
          <div class="flex items-center grow space-x-1.5">
            <IconBase :name="option.icon" :width="18" v-if="option.icon" />
            <p>{{ option.label }}</p>
          </div>

          <p class="text-xs opacity-60 leading-none mt-0.5" v-if="option.subtitle">{{ option.subtitle }}</p>
        </div>
      </div>

      <ButtonBase
        class="!absolute top-0 left-0 duration-300 ease-out pointer-events-none"
        v-bind="{ ...button, ...(currentItem?.button || {}) }"
        :style="{
          width: currentItem.width + 'px',
          transform: `translateX(${currentItem.left + 'px'})`,
        }"
        v-if="currentItem"
      >
        <IconBase :name="currentItem.icon + '-fill'" :width="18" class="mr-1.5" v-if="currentItem.icon" />

        {{ currentItem?.label }}

        <template #subtitle v-if="currentItem?.subtitle">
          {{ currentItem?.subtitle }}
        </template>
      </ButtonBase>
    </div>
  </div>
</template>

<script lang="ts" setup>
interface ButtonOption {
  label?: string 
  subtitle?: string
  value: string | number | boolean
  icon?: string
  button?: {
    size?: string,
    color?: string
  }
}

const props = defineProps<{
  modelValue: string | number | boolean
  options: ButtonOption[]
  isResettable?: boolean
  isSeparations?: boolean
  button?: {
    size?: string,
    color?: string
  }
}>()

const emit = defineEmits<{
  (e: 'update:modelValue', v: string | number | boolean): void
  (e: 'reset'): void
  (e: 'change'): void
}>()

const { modelValue, options } = toRefs(props)

const currentItem = computed(() => {
  return items.value.find(item => item.value === props.modelValue)
})

const $items = ref([])
const items: Ref<(ButtonOption & { width: number, left: number })[]> = ref([])

const refresh = () => {
  setTimeout(() => {
    items.value = props.options.map(item => {
      const $item = $items.value.find(($item: any) => {
        return $item && $item.getAttribute('data-value') === `${item.value}`
      }) as any

      let width = 0
      let left = 0

      if ($item) {
        const { width: calculatedWidth } = $item.getBoundingClientRect()
        width = Math.round(calculatedWidth)
        left = $item.offsetLeft
      }

      return {
        ...item,
        left,
        width
      }
    })
  })
}

watch(options, () => refresh())
onMounted(() => refresh())

</script>